import { useContext } from 'react';
import { AlertContext } from '../contexts/AlertContextProvider';

export default function useAlert() {
  return useContext(AlertContext).showAlert;
}
